import { Button } from '@/components/Button'
import { Icon } from '@/components/Icon'
import styles from './CallChip.module.css'

export interface VideoCallChipProps {
  isJoinDisabled: boolean
  isJoinPending: boolean
  onJoin: () => unknown
}

export function VideoCallChip({
  isJoinDisabled,
  isJoinPending,
  onJoin,
}: VideoCallChipProps) {
  return (
    <div className={styles.root}>
      <Icon name="call-video-on" size={16} aria-hidden />
      <div className={styles.text}>
        <div className={styles.title}>Video call</div>
        <div className={styles.subtitle}>Join whenever you’re both ready</div>
      </div>
      <Button
        label="Join"
        size="small"
        variant="primary"
        isDisabled={isJoinDisabled}
        isPending={isJoinPending}
        onPress={onJoin}
      />
    </div>
  )
}
